import { memo, ReactNode } from "react";
import styled from "styled-components";

const Panel = styled.section`
  border-top: solid 1px #e8e8ef;
  margin: 20px -50px 0;
  padding: 30px 50px 0;
  @media only screen and (max-width: 992px) {
    margin-left: -20px;
    margin-right: -20px;
    margin-top: 10px;
    padding: 15px 0px;
  }

  h2 {
    margin-bottom: 35px;
    font-weight: 500;
    font-size: 1.5rem;
    display: block;

    @media only screen and (max-width: 992px) {
      padding-left: 20px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  border: solid 1px #e8e8ef;
  margin-bottom: 10px;

  @media only screen and (max-width: 992px) {
    margin: 0 20px -5px;
  }
`;

interface ContentPanelProps {
  title: string;
  children: ReactNode;
}

const ContentPanel = (props: ContentPanelProps) => {
  const { title, children } = props;

  return (
    <Panel>
      <h2>{title}</h2>
      <Container>{children}</Container>
    </Panel>
  );
};

export default memo(ContentPanel);
